import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const createUserNotify = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/email/createUserNotify',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_USER_NOTIFY,
        [
          () => {
            return {'type': ActionTypes.CREATED_WTS_USER_NOTIFY};
          },
          MessageActions.addMessageBoxInfo('Notificación de usuario enviada satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_USER_NOTIFY_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const createCourseNotify = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/email/createCourseNotify',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_COURSE_NOTIFY,
        [
          () => {
            return {'type': ActionTypes.CREATED_WTS_COURSE_NOTIFY};
          },
          MessageActions.addMessageBoxInfo('Notificación de curso enviada satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_COURSE_NOTIFY_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateUserNotify = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/email/updateUserNotify',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_USER_NOTIFY,
        [
          () => {
            return {'type': ActionTypes.UPDATED_WTS_USER_NOTIFY};
          },
          MessageActions.addMessageBoxInfo('Notificación de actualización enviada satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_USER_NOTIFY_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateCourseNotify = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/email/updateCourseNotify',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_COURSE_NOTIFY,
        [
          () => {
            return {'type': ActionTypes.UPDATED_WTS_COURSE_NOTIFY};
          },
          MessageActions.addMessageBoxInfo('Notificación de actualización de curso enviada satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_COURSE_NOTIFY_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const closeCourseNotify = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/email/closeCourseNotify',
      'authenticated': true,
      'types': [
        ActionTypes.CLOSING_WTS_COURSE_NOTIFY,
        [
          () => {
            return {'type': ActionTypes.CLOSED_WTS_COURSE_NOTIFY};
          },
          MessageActions.addMessageBoxInfo('Notificación de cierre de curso enviada satisfactoriamente'),
        ],
        [
          ActionTypes.CLOSED_WTS_COURSE_NOTIFY_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const cancelCourseNotify = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/email/cancelCourseNotify',
      'authenticated': true,
      'types': [
        ActionTypes.CANCELLING_WTS_COURSE_NOTIFY,
        [
          () => {
            return {'type': ActionTypes.CANCELLED_WTS_COURSE_NOTIFY};
          },
          MessageActions.addMessageBoxInfo('Notificación de cancelación de curso enviada satisfactoriamente'),
        ],
        [
          ActionTypes.CANCELLED_WTS_COURSE_NOTIFY_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
